/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default [
    {
        path: '/company/users',
        name: 'CompanyUsers',
        component: () => import('@/views/Company/Users.vue'),
        meta: { permission: 'users.view' }
    },
    {
        path: '/company/user/create',
        name: 'CreateCompanyUser',
        component: () => import('@/views/Company/UserBuilder.vue'),
        meta: { permission: 'users.create' }
    },
    {
        path: '/company/user/:userId/profile',
        name: 'UserProfile',
        component: () => import('@/views/Company/UserProfile.vue'),
        meta: { permission: 'users.view' }
    },
    {
        path: '/company/user/:userId/edit',
        name: 'EditCompanyUser',
        component: () => import('@/views/Company/UserBuilder.vue'),
        meta: { permission: 'users.update' }
    },
    {
        path: '/company/citizens',
        name: 'CompanyCitizens',
        component: () => import('@/views/Company/Citizens.vue'),
        meta: { permission: 'users.view' }
    },
    {
        path: '/company/citizens/create',
        name: 'CreateCompanyCitizen',
        component: () => import('@/views/Company/CitizenBuilder.vue'),
        meta: { permission: 'users.create' }
    },
    {
        path: '/company/webhooks',
        name: 'CompanyWebhooks',
        component: () => import('@/views/Company/Webhooks.vue'),
        meta: { permission: 'company.settings' }
    },
    {
        path: '/company/webhooks/create',
        name: 'CreateCompanyWebhook',
        component: () => import('@/views/Company/WebhookBuilder.vue'),
        meta: { permission: 'company.settings' }
    },
    {
        path: '/company/webhooks/:webhookId/edit',
        name: 'EditCompanyWebhook',
        component: () => import('@/views/Company/WebhookBuilder.vue'),
        meta: { permission: 'company.settings' }
    },
    {
        path: '/company/settings',
        name: 'CompanySettings',
        component: () => import('@/views/Company/Settings.vue'),
        meta: { permission: 'company.settings' }
    },
    {
        path: '/company/roles',
        name: 'CompanyRoles',
        component: () => import('@/views/Company/Roles.vue'),
        meta: { permission: 'roles.manage' }
    },
    {
        path: '/company/roles/:roleId/permissions',
        name: 'CompanyRolePermissions',
        component: () => import('@/views/Company/RolePermissions.vue'),
        meta: { permission: 'roles.manage' }
    },
    {
        // Ancienne matrice rôles x permissions : les droits se gèrent
        // désormais rôle par rôle depuis la liste des rôles.
        path: '/company/permissions',
        redirect: '/company/roles'
    },
    {
        path: '/company/backoffice-infos',
        name: 'BackofficeInfos',
        component: () => import('@/views/Company/BackofficeInfos.vue'),
        meta: { permission: 'company.settings' }
    }
]
